import React from 'react'
import scrollimg from "../../../assets/images/scrool2.png"

import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { P, SectionHeading } from '../../Styles/style';

const Iasdmg = styled.img`  
width: 100%;
height:auto;
max-width: ${(props) => (props.maxWidth ? props.maxWidth : "300px")};
`
const Div = styled.div`
 /* background: ${(props) => (props.bgcolor ? props.bgcolor : "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)")}; */
  border-top: 1px solid #88F846;
  border-bottom: 1px solid #88F846;
  padding: ${(props) => (props.padding ? props.padding : "8px 0")};
`
const GridInside = styled(Grid)`
display: flex;
    place-content: center;
`

const Swipe = (props) => {
    return (
        // "linear-gradient(235deg, #00EAFF 20%,#0080FF 30%,#0080FF 27%,#8000FF 43%, #E619E6 60%,#FF0000 92%)"
        // DracoMalfoyPowellCarlosZelda1000XInu
        <Div bgcolor={props.bgcolor}>
            <marquee scrollamount={props.scrollamount} behavior="scroll" direction="left" loop="infinite">
                <SectionHeading fm="EBI" color="#88F846" fs="50px">
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                SeverusSnapeClintonCarlosLink1000XInu
                </SectionHeading>
            </marquee>
        </Div>
    )
}

export default Swipe